export const LoraChart = {
  RSSI: 'rssi', // TODO rssi
  SNR: 'snr', // TODO snr
  LeafWetness: 'leafWetness',
  WM1: 'wm1',
  WM2: 'wm2',
  PH: 'ph',
  LiquidLevel: 'liquidLevel',
  LiquidTemperature: 'liquidTemperature',
  MR: 'mr',
  MR1: 'mr1',
  MR2: 'mr2',
  ST: 'st',
  ST1: 'st1',
  ST2: 'st2',
  ST3: 'st3',
  ST4: 'st4',
  ST5: 'st5',
  ST6: 'st6',
  ST7: 'st7',
  ST8: 'st8',
  ST9: 'st9',
  WP: 'wp',
  WP1: 'wp1',
  WP2: 'wp2',
  SM: 'sm',
  SM1: 'sm1',
  SM2: 'sm2',
  SM3: 'sm3',
  SM4: 'sm4',
  SM5: 'sm5',
  SM6: 'sm6',
  SM7: 'sm7',
  SM8: 'sm8',
  SM9: 'sm9',
  SS: 'ss',
  SS1: 'ss1',
  SS2: 'ss2',
  SS3: 'ss3',
  SS4: 'ss4',
  SS5: 'ss5',
  SS6: 'ss6',
  SS7: 'ss7',
  SS8: 'ss8',
  SS9: 'ss9',
  At: 'at',
  Atd: 'atd',
  Ah: 'ah',
  Rm: 'rm',
  Aws: 'aws',
  Mws: 'mws',
  Ap: 'ap',
  LUX: 'lux',
  Bv: 'bv',
  Sr: 'sr',
  Awa: 'awa',

  AllByCode: 'allByCode',

  TotalPerDevice: 'totalPerDevice',
  PerDevice: 'perDevice',

  AtPerDevice: 'atPerDevice',
  SM1PerDevice: 'sm1PerDevice',
  SM2PerDevice: 'sm2PerDevice',
  PosPerDevice: 'posPerDevice',

  frontGraph: 'frontGraph',
};
